import type { CategoryMM } from '~/entities';
import {
  ETrackerActions,
  ETrackerPages,
  ETrackerChapters,
  useTracker,
} from '~/features/clickstream-sdk';
import { useCategories } from '../business/useCategories';

export function useCategoriesTracker() {
  const { _getTrackerPayload } = useCategories();

  const _trackerPayload = _getTrackerPayload();

  const { track } = useTracker({
    chapter: ETrackerChapters.MARKET,
    page: ETrackerPages.CATALOG,
    action: ETrackerActions.CLICK,
  });

  function trackCategoryClick(category: CategoryMM) {
    const current_category_id = category.path.pop();
    const source_category_id = category.path.pop();

    return track({
      action: ETrackerActions.CLICK,
      block: 'categoryList',
      element: 'category',
      category_list: _trackerPayload.category_list,
      depth_level: category.path.length,
      category_name: category.title,
      current_category_id,
      source_category_id,
    });
  }

  function trackAllCategoriesClick(current_category_id: number) {
    return track({
      action: ETrackerActions.CLICK,
      element: 'allCategoriesButton',
      category_list: _trackerPayload.category_list,
      current_category_id,
    });
  }

  return { trackCategoryClick, trackAllCategoriesClick };
}
